// @flow

import React, { type Node, createContext, useContext } from 'react';

import useAllServicesLoader from './useAllServicesLoader';

import type { ServiceLoaderResults } from './types';

// Only exported so that unit tests can create a provider passing mock data
export const AllServicesContext = createContext<ServiceLoaderResults | void>();

type ProviderProps = {
  includePrivate: boolean,
  children: Node,
};

export const AllServicesProvider = ({
  includePrivate,
  children,
}: ProviderProps) => {
  const context = useAllServicesLoader({ includePrivate });

  return (
    <AllServicesContext.Provider value={context}>
      {children}
    </AllServicesContext.Provider>
  );
};

export const useAllServices = () => {
  const context = useContext(AllServicesContext);
  if (context === undefined) {
    throw new Error('AllServicesProvider was not provided');
  }

  return context;
};
